<mwe-modal [model]="popupModel()">
  <div class="text-center">
    @if (popupData()?.title) {
      <h4 class="mb-5">{{ popupData()?.title }}</h4>
    }

    <div class="mb-5">
      <h6>{{ popupData()?.newClientText }}</h6>
      @if (popupData()?.newClientTextParagraph) {
        <p class="text--big">{{ popupData()?.newClientTextParagraph }}</p>
      }
      <mwe-button
        buttonId="mwe-campaign-popup-newclient-button"
        class="campaign-popup-button"
        [labelKey]="popupData()?.newClientButton"
        (clicked)="startNewClientProcess()"
      />
    </div>

    <div>
      <h6>{{ popupData()?.tariffChangeText }}</h6>
      @if (popupData()?.tariffChangeTextParagraph) {
        <p class="text--big">{{ popupData()?.tariffChangeTextParagraph }}</p>
      }
      <mwe-button
        buttonId="mwe-campaign-popup-tariffchange-button"
        class="campaign-popup-button"
        color="blue"
        [labelKey]="popupData()?.tariffChangeButton"
        (clicked)="startTariffChangeProcess()"
      />
    </div>
  </div>
</mwe-modal>
